module.exports = __webpack_public_path__ + "img/icon-clicks.d59283f7.svg";